<div class="bg-brand-surface-raised flex items-center justify-center min-h-screen p-4">
  <div class="w-full max-w-[88%] flex flex-col lg:flex-row gap-15">
    <!-- Sección izquierda con ícono central grande y texto en su posición original -->
    <div
      class="relative w-full lg:w-1/2 rounded-3xl shadow-md h-auto lg:h-[90vh] overflow-hidden
             bg-[radial-gradient(circle_at_top_left,_#3366FF_0%,_#16173A_70%,_#16173A_100%)]"
    >
      <!-- Ícono Blurring_lock centrado (20× más grande) -->
      <img
        src="/assets/icons/Auth/Blurring_lock.svg"
        alt="Blurring Lock Icon"
        class="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 h-[720px] w-[720px] opacity-80"
      />

      <!-- Texto en la posición original (arriba a la izquierda) -->
      <div class="relative z-10 p-8 lg:p-12 flex flex-col items-start">
        <h1 class="text-white font-bold leading-tight text-2xl sm:text-3xl md:text-4xl lg:text-5xl xl:text-6xl">
          {{ 'AUTH.HERO_TITLE' | translate }}
        </h1>
      </div>
    </div>

    <!-- Sección derecha para la recuperación de contraseña -->
    <div
      class="w-full lg:w-1/2 bg-white rounded-3xl shadow-md h-auto lg:h-[90vh] flex items-center justify-center"
    >
      <div class="w-full max-w-xl px-12 py-16">
        <!-- Padlock icon alineado a la izquierda -->
        <div class="flex justify-start mb-6">
          <div class="bg-blue-50 rounded-full p-4">
            <img
              src="/assets/icons/Auth/Padlock.svg"
              alt="Padlock Icon"
              class="h-12 w-12"
            />
          </div>
        </div>

        <!-- Título (mismo estilo que "Welcome Back") -->
        <h2 class="text-5xl font-bold text-gray-800 mb-4">{{ 'AUTH.FORGOT_PASSWORD.TITLE' | translate }}</h2>
        <p class="text-lg text-gray-600 mb-12">
          {{ 'AUTH.FORGOT_PASSWORD.SUBTITLE' | translate }}
        </p>

        <form [formGroup]="forgotForm" (ngSubmit)="onSubmit()" class="space-y-10">
          <!-- Email -->
          <div>
            <label for="email" class="block text-lg font-medium text-gray-700 mb-2 required-marker">{{ 'AUTH.FORGOT_PASSWORD.EMAIL_LABEL' | translate }}</label>
            <div class="relative">
              <div class="absolute inset-y-0 left-0 flex items-center pl-5 pointer-events-none">
                <svg class="h-6 w-6 text-gray-400" fill="currentColor" viewBox="0 0 20 20">
                  <path d="M2 5a2 2 0 012-2h12a2 2 0 012 2v.217l-8 4.8-8-4.8V5z" />
                  <path d="M2 7.383l8 4.8 8-4.8V15a2 2 0 01-2 2H4a2 2 0 01-2-2V7.383z" />
                </svg>
              </div>
              <input
                id="email"
                type="email"
                formControlName="email"
                autocomplete="email"
                required
                class="block w-full pl-14 pr-4 py-4 border border-gray-300 rounded-lg
                       focus:outline-none focus:ring-2 focus:ring-blue-500 text-lg"
                [placeholder]="'AUTH.FORGOT_PASSWORD.EMAIL_PLACEHOLDER' | translate"
              />
            </div>
            <div *ngIf="submitted && forgotForm.controls['email'].invalid" class="text-red-600 text-sm mt-1">
              <div *ngIf="forgotForm.controls['email'].errors?.['required']">
                {{ 'AUTH.FORGOT_PASSWORD.EMAIL_REQUIRED' | translate }}
              </div>
              <div *ngIf="forgotForm.controls['email'].errors?.['email']">
                {{ 'AUTH.FORGOT_PASSWORD.EMAIL_INVALID' | translate }}
              </div>
            </div>
          </div>

          <!-- Submit -->
          <div>
            <button
              type="submit"
              [disabled]="loading"
              class="w-full flex justify-center py-5 px-6 border border-transparent rounded-lg shadow-sm
                     text-xl text-white bg-blue-600 hover:bg-blue-700 focus:outline-none focus:ring-2 focus:ring-blue-500"
            >
              {{ 'AUTH.FORGOT_PASSWORD.SUBMIT' | translate }}
            </button>
          </div>

          <!-- Mensajes -->
          <div *ngIf="successMessage" class="text-green-600 text-center text-lg">
            {{ successMessage }}
          </div>
          <div *ngIf="errorMessage" class="text-red-600 text-center text-lg">
            {{ errorMessage }}
          </div>

          <!-- Back to Login -->
          <div class="mt-8 text-center">
            <button
              (click)="goToLogin()"
              class="inline-flex items-center px-4 py-2 border border-gray-300 text-gray-700
                     bg-white hover:bg-gray-50 rounded-md font-medium focus:outline-none focus:ring-2 focus:ring-blue-400"
            >
              <svg xmlns="http://www.w3.org/2000/svg"
                   class="h-5 w-5 mr-2 text-gray-600"
                   fill="none"
                   viewBox="0 0 24 24"
                   stroke="currentColor"
                   stroke-width="2"
              >
                <path stroke-linecap="round" stroke-linejoin="round" d="M15 19l-7-7 7-7" />
              </svg>
              {{ 'AUTH.BACK_TO_LOGIN' | translate }}
            </button>
          </div>
        </form>
      </div>
    </div>
  </div>
</div>
